import React from "react";
import { withRouter } from "react-router-dom";

import Slider from "rc-slider";
import { defineGrid, extendHex, Point } from "honeycomb-grid";

import { ScrollSync, ScrollSyncPane } from "react-scroll-sync";

import { Popover, OverlayTrigger } from "react-bootstrap";

import { Modal } from "react-bootstrap";

import Select from "react-select";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagic, faCheckCircle, faShare, faRetweet, faSearch, faUndo } from "@fortawesome/free-solid-svg-icons";

import { Button, ButtonGroup, Icon } from "aible";
import { LineInput } from "components/Inputs/LineInput";

import HexagonContainer from "containers/Next/Hexagon";

import Hexagon from "components/Next/Hexagon";
import { DATA_SOURCES, DATASET_REFRESH_RATE_OPTIONS, findDataSourceDetails } from "containers/SchemaMonitor/reducer";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import * as nextReducer from "containers/Next/NextReducer";

import { isEnabled } from "utils/featureFlags";

import styles from "./style.module.css";

import { DEFAULT_MIN_EXPLORE_SAMPLE_SIZE } from "utils/insight/insights";

import { GoogleLogin, GoogleLogout } from "react-google-login";
import { gapi } from "gapi-script";

const CLIENT_ID = "";
let ACCESS_TOKEN = "";

import { rgb } from "d3-color";
import { MAX_ARCS } from "containers/Home/reducer";

export default class GoogleSlidesExport extends React.PureComponent {
  constructor(props) {
    super(props);

    const initClient = () =>
      gapi.client.init({
        clientId: CLIENT_ID,
        scope: "https://www.googleapis.com/auth/spreadsheets https://www.googleapis.com/auth/presentations"
      });

    gapi.load("client:auth2", initClient);

    this.state = {
      isGoogleLogin: false
    };
  }

  buildCellRequest(column, row, value) {
    return {
      repeatCell: {
        range: {
          startColumnIndex: column,
          endColumnIndex: column + 1,
          startRowIndex: row,
          endRowIndex: row + 1,
          sheetId: 0
        },
        cell: {
          userEnteredValue: isNaN(value)
            ? {
                stringValue: value
              }
            : { numberValue: value }
        },
        fields: "*"
      }
    };
  }

  updateSheetFirstOrder(sheetId, chart, startRow = 0) {
    let requests = [];

    const retData = chart?.chart?.data
      ? chart?.chart?.data.sort((a, b) => (a.name < b.name ? -1 : b.name < a.name ? 1 : 0))
      : [];

    requests.push(this.buildCellRequest(0, startRow, chart?.metadata?.properties?.[0]?.column));
    requests.push(this.buildCellRequest(1, startRow, chart?.narrative?.title));

    for (let i = 0; i < retData.length; i++) {
      const dItem = retData?.[i];

      requests.push(this.buildCellRequest(0, i + 1 + startRow, dItem.name));

      requests.push(this.buildCellRequest(1, i + 1 + startRow, dItem.y === undefined ? 0 : dItem.y));
    }

    return fetch(`https://sheets.googleapis.com/v4/spreadsheets/${sheetId}:batchUpdate`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        //update this token with yours.
        Authorization: `Bearer ${ACCESS_TOKEN}`
      },
      body: JSON.stringify({
        requests: requests
      })
    }).then((r) => this.handleResponse(r));
  }

  updateSheet(sheetId, chart, startRow = 0) {
    let requests = [];

    const retData = chart?.chart?.data
      ? chart?.chart?.data.sort((a, b) => (a.name < b.name ? -1 : b.name < a.name ? 1 : 0))
      : [];

    requests.push(this.buildCellRequest(0, startRow, chart?.metadata?.properties?.[0]?.column));
    requests.push(this.buildCellRequest(1, startRow, chart?.narrative?.conditionsLabel));
    requests.push(this.buildCellRequest(2, startRow, chart?.metadata?.properties?.[1]?.column + " is all other"));

    for (let i = 0; i < retData.length; i++) {
      const dItem = retData?.[i];

      requests.push(this.buildCellRequest(0, i + 1 + startRow, dItem.name));

      requests.push(this.buildCellRequest(1, i + 1 + startRow, dItem.y === undefined ? 0 : dItem.y));
      requests.push(this.buildCellRequest(2, i + 1 + startRow, dItem.otherY));
    }

    return fetch(`https://sheets.googleapis.com/v4/spreadsheets/${sheetId}:batchUpdate`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        //update this token with yours.
        Authorization: `Bearer ${ACCESS_TOKEN}`
      },
      body: JSON.stringify({
        requests: requests
      })
    }).then((r) => this.handleResponse(r));
  }

  updateSheetLineChart(sheetId, chart, startRow = 0) {
    const retData = chart?.data.sort((a, b) => {
      if (isNaN(a.name) || isNaN(b.name)) {
        return a.name < b.name ? -1 : b.name < a.name ? 1 : 0;
      } else {
        return Number(a.name) < Number(b.name) ? -1 : Number(b.name) < Number(a.name) ? 1 : 0;
      }
    });
    const lineKeys =
      retData?.[0] === undefined
        ? []
        : Object.keys(retData[0])
            .filter(
              (cKey) => cKey !== "count" && cKey !== "name" && cKey !== "column" && cKey !== "min" && cKey !== "max"
            )
            .filter((c, i) => i < 5);

    let requests = [];

    console.log("what is lineKeys chart", lineKeys, chart);

    requests.push(this.buildCellRequest(0, startRow, chart?.title));

    lineKeys.forEach((lineKey, i) => {
      requests.push(this.buildCellRequest(i + 1, startRow, lineKey));
    });

    for (let i = 0; i < retData.length; i++) {
      const dItem = retData?.[i];

      requests.push(this.buildCellRequest(0, i + 1 + startRow, dItem.name));

      lineKeys.forEach((lineKey, j) => {
        requests.push(this.buildCellRequest(j + 1, i + 1 + startRow, dItem[lineKey]));
      });
    }

    return fetch(`https://sheets.googleapis.com/v4/spreadsheets/${sheetId}:batchUpdate`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        //update this token with yours.
        Authorization: `Bearer ${ACCESS_TOKEN}`
      },
      body: JSON.stringify({
        requests: requests
      })
    }).then((r) => this.handleResponse(r));
  }

  handleExport() {
    const { exportCharts } = this.props;

    return this.exportSearch(exportCharts);
  }

  timeout(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  async exportDashboard() {
    const { allCharts } = this.props;

    this.setState({ isDashboardBuilding: true });

    console.log("Export dashboard!", allCharts, this.props);

    let startRow = 0;

    try {
      const sheetResponse = await this.createSheet();
      const presResponse = await this.createPresentation();

      console.log("what is sheet?, pres", sheetResponse, presResponse);

      const sheetId = sheetResponse?.spreadsheetId;
      const presentationId = presResponse?.presentationId;

      const shapeResponse = await this.addShape(presentationId, "p");

      console.log("what is shape??", shapeResponse);

      const shapeId = shapeResponse?.replies[0]?.createShape?.objectId;

      const updateShapeResponse = await this.updateShape(presentationId, shapeId);

      /*
      { magnitude: 5143500, unit: "EMU" },
      width = {
        magnitude: 9144000,
        unit: "EMU",
      }
      */

      const imgLogoResp = await this.addImageToSlide(
        presentationId,
        "p",
        "https://bigquery.d.aiplusi.com/d4c67630dff9577d09803147739f1ac4.png",
        {
          scaleX: 1,
          scaleY: 1,
          translateX: 300000,
          translateY: 20000,
          unit: "EMU"
        },
        { magnitude: 1000000, unit: "EMU" },
        { magnitude: 2000000, unit: "EMU" }
      );

      const imgPatternResp = await this.addImageToSlide(
        presentationId,
        "p",
        "https://bigquery.d.aiplusi.com/a950005562eb24b89784809e9311056c.png",
        undefined
      );

      console.log("what is updateShape??", updateShapeResponse);

      window.open("https://docs.google.com/presentation/d/" + presentationId);

      let slideIndex = 0;
      for (const chart of allCharts) {
        console.log("what is chart?", chart);

        const slideId = "slideId" + slideIndex;
        const slideResponse = await this.createSlide(presentationId, slideId);

        console.log("new slide", slideResponse);

        const uResponse = await this.updateSheetLineChart(sheetId, chart, startRow);

        const aResponse = await this.addChartLine(sheetId, chart, startRow);

        const cResp = await this.addChartsToSlide(
          sheetId,
          presentationId,
          slideId,
          aResponse?.replies?.[0]?.addChart?.chart?.chartId,
          0
        );

        console.log("update sheet response", uResponse);

        startRow += chart?.data.length + 2;

        const secondCharts = chart?.secondaryCharts.filter((c, i) => i < 3);

        let sIndex = 0;
        for (const sChart of secondCharts) {
          const bResponse = await this.updateSheet(sheetId, sChart, startRow);
          const cResponse = await this.addChart(sheetId, sChart, startRow);

          const cRespSecond = await this.addChartsToSlide(
            sheetId,
            presentationId,
            slideId,
            cResponse?.replies?.[0]?.addChart?.chart?.chartId,
            sIndex + 1
          );

          startRow += sChart?.chart.data.length + 2;
          sIndex++;
        }

        const smallShapeResponse = await this.addShapeSmall(presentationId, slideId, 0);

        const smallShapeId = smallShapeResponse?.replies?.[0]?.createShape?.objectId;

        if (smallShapeId !== undefined) {
          const upSmallShape = await this.updateShape(presentationId, smallShapeId);

          const textResponse = await this.updateShapeText(
            presentationId,
            smallShapeId,
            chart?.title || chart?.narrative?.title
          );
          const textStyleResp = await this.updateTextStyle(presentationId, smallShapeId, true);
        }

        let nIndex = 0;
        for (const sChart of secondCharts) {
          const sResp = await this.addShapeSmall(presentationId, slideId, nIndex + 1);
          const sShapeId = sResp?.replies?.[0]?.createShape?.objectId;

          if (sShapeId !== undefined) {
            const sUpdateResp = await this.updateShape(presentationId, sShapeId);
            const sTextResp = await this.updateShapeText(presentationId, sShapeId, sChart?.narrative?.title);
            const textStyleResp = await this.updateTextStyle(presentationId, sShapeId);
          }

          nIndex++;
        }

        slideIndex++;
      }

      this.setState({ isDashboardBuilding: false });

      return Promise.resolve();

      /*
        this.createPresentation().then((presResponse) => {
          console.log("what is slide?", presResponse);
        });
      });
      */
    } catch (e) {
      console.log("Export Error: ", e);
      this.setState({ isDashboardBuilding: false });
    }
  }

  async exportSearch(searchInsights) {
    const retData = searchInsights;

    this.setState({ isDashboardBuilding: true });

    console.log("Export search!", retData, this.props);

    let startRow = 0;

    const sheetResponse = await this.createSheet();
    const presResponse = await this.createPresentation();

    console.log("what is sheet?, pres", sheetResponse, presResponse);

    const sheetId = sheetResponse?.spreadsheetId;
    const presentationId = presResponse?.presentationId;

    window.open("https://docs.google.com/presentation/d/" + presentationId);

    let slideIndex = 0;
    for (const chart of retData) {
      console.log("what is chart?", chart);

      const slideId = slideIndex === 0 ? "p" : "slideId" + slideIndex;
      if (slideIndex > 0) {
        const slideResponse = await this.createSlide(presentationId, slideId);
        console.log("new slide", slideResponse);
      }

      const uResponse =
        chart?.metadata?.properties && chart?.metadata?.properties.length === 1
          ? await this.updateSheetFirstOrder(sheetId, chart, startRow)
          : await this.updateSheet(sheetId, chart, startRow);

      const aResponse =
        chart?.metadata?.properties && chart?.metadata?.properties.length === 1
          ? await this.addChartFirstOrder(sheetId, chart, startRow)
          : await this.addChart(sheetId, chart, startRow);

      this.addChartsToSlide(sheetId, presentationId, slideId, aResponse?.replies?.[0]?.addChart?.chart?.chartId, -1);

      console.log("update sheet response", uResponse);

      startRow += chart?.chart?.data.length + 2;

      slideIndex++;
    }

    this.setState({ isDashboardBuilding: false });

    return Promise.resolve();

    /*
      this.createPresentation().then((presResponse) => {
        console.log("what is slide?", presResponse);
      });
    });
    */
  }

  createSheet() {
    return fetch(`https://sheets.googleapis.com/v4/spreadsheets`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        //update this token with yours.
        Authorization: `Bearer ${ACCESS_TOKEN}`
      },
      body: JSON.stringify({
        properties: { title: "Aible Insights Spreadsheet" }
      })
    }).then((r) => this.handleResponse(r));
  }

  createPresentation() {
    return fetch(`https://slides.googleapis.com/v1/presentations`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        //update this token with yours.
        Authorization: `Bearer ${ACCESS_TOKEN}`
      },
      body: JSON.stringify({ title: "Aible Insights" })
    }).then((r) => this.handleResponse(r));
  }

  createSlide(presentationId, slideId) {
    return fetch(`https://slides.googleapis.com/v1/presentations/${presentationId}:batchUpdate`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        //update this token with yours.
        Authorization: `Bearer ${ACCESS_TOKEN}`
      },
      body: JSON.stringify({
        requests: [{ createSlide: { objectId: slideId } }]
      })
    }).then((r) => this.handleResponse(r));
  }

  addChartLine(sheetId, chart, startRow) {
    const { dataset } = this.props;

    const retData = chart?.data;
    const lineKeys =
      retData?.[0] === undefined
        ? []
        : Object.keys(retData[0])
            .filter(
              (cKey) => cKey !== "count" && cKey !== "name" && cKey !== "column" && cKey !== "min" && cKey !== "max"
            )
            .filter((c, i) => i < 5);

    let series = [];

    lineKeys.forEach((lineKey, i) => {
      const color = chart?.colors[i];
      const rColor = rgb(color);

      series.push({
        series: {
          sourceRange: {
            sources: [
              {
                sheetId: 0,
                startRowIndex: startRow,
                endRowIndex: startRow + retData.length + 1,
                startColumnIndex: i + 1,
                endColumnIndex: i + 2
              }
            ]
          }
        },
        colorStyle: {
          rgbColor: {
            red: rColor.r / 255,
            green: rColor.g / 255,
            blue: rColor.b / 255,
            alpha: rColor.opacity
          }
        },
        targetAxis: "LEFT_AXIS"
      });
    });

    return fetch(`https://sheets.googleapis.com/v4/spreadsheets/${sheetId}:batchUpdate`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        //update this token with yours.
        Authorization: `Bearer ${ACCESS_TOKEN}`
      },
      body: JSON.stringify({
        requests: [
          {
            addChart: {
              chart: {
                spec: {
                  title: chart?.title,
                  basicChart: {
                    chartType: "LINE",
                    legendPosition: "BOTTOM_LEGEND",
                    axis: [
                      {
                        position: "BOTTOM_AXIS",
                        title: ""
                      },
                      {
                        position: "LEFT_AXIS",
                        title: dataset?.outcome
                      }
                    ],
                    domains: [
                      {
                        domain: {
                          sourceRange: {
                            sources: [
                              {
                                sheetId: 0,
                                startRowIndex: startRow,
                                endRowIndex: startRow + retData.length + 1,
                                startColumnIndex: 0,
                                endColumnIndex: 1
                              }
                            ]
                          }
                        }
                      }
                    ],
                    series: series,
                    headerCount: 1
                  }
                },
                position: {
                  newSheet: true
                }
              }
            }
          }
        ]
      })
    }).then((r) => this.handleResponse(r));
  }

  addShape(presentationId, slideId) {
    const { dataset } = this.props;

    const eFullHeight = {
      magnitude: 5143500,
      unit: "EMU"
    };

    const eFullWidth = {
      magnitude: 9144000,
      unit: "EMU"
    };

    return fetch(`https://slides.googleapis.com/v1/presentations/${presentationId}:batchUpdate`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        //update this token with yours.
        Authorization: `Bearer ${ACCESS_TOKEN}`
      },
      body: JSON.stringify({
        requests: [
          {
            createShape: {
              elementProperties: {
                pageObjectId: slideId,
                size: {
                  height: eFullHeight,
                  width: eFullWidth
                }
              },
              shapeType: "TEXT_BOX"
            }
          }
        ]
      })
    }).then((r) => this.handleResponse(r));
  }

  addShapeSmall(presentationId, slideId, chartIndex) {
    const eWidthLarge = {
      magnitude: 5000000,
      unit: "EMU"
    };

    const eWidthSmall = {
      magnitude: 3000000,
      unit: "EMU"
    };

    const eHeightSmall = {
      magnitude: 300000,
      unit: "EMU"
    };

    const eHeightLarge = {
      magnitude: 370000,
      unit: "EMU"
    };

    const translateX =
      chartIndex === -1
        ? 0
        : chartIndex === 0
          ? 1900000
          : chartIndex === 1
            ? 0
            : chartIndex === 2
              ? 3000000
              : chartIndex === 3
                ? 6000000
                : 6000000;
    const translateY =
      chartIndex === -1
        ? 0
        : chartIndex === 0
          ? 10000
          : chartIndex === 1
            ? 3200000
            : chartIndex === 2
              ? 3200000
              : chartIndex === 3
                ? 3200000
                : 3200000;

    return fetch(`https://slides.googleapis.com/v1/presentations/${presentationId}:batchUpdate`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        //update this token with yours.
        Authorization: `Bearer ${ACCESS_TOKEN}`
      },
      body: JSON.stringify({
        requests: [
          {
            createShape: {
              elementProperties: {
                pageObjectId: slideId,
                size: {
                  height: chartIndex === 0 ? eHeightLarge : eHeightSmall,
                  width: chartIndex === 0 ? eWidthLarge : eWidthSmall
                },
                transform: {
                  scaleX: 1,
                  scaleY: 1,
                  translateX: translateX,
                  translateY: translateY,
                  unit: "EMU"
                }
              },
              shapeType: "TEXT_BOX"
            }
          }
        ]
      })
    }).then((r) => this.handleResponse(r));
  }

  updateTextStyle(presentationId, shapeId, isLarge = false) {
    return fetch(`https://slides.googleapis.com/v1/presentations/${presentationId}:batchUpdate`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        //update this token with yours.
        Authorization: `Bearer ${ACCESS_TOKEN}`
      },
      body: JSON.stringify({
        requests: [
          {
            updateTextStyle: {
              objectId: shapeId,
              style: {
                foregroundColor: {
                  opaqueColor: {
                    rgbColor: {
                      red: 1,
                      green: 1,
                      blue: 1
                    }
                  }
                },
                fontSize: {
                  magnitude: isLarge ? 13 : 9,
                  unit: "PT"
                }
              },
              fields: "foregroundColor.opaqueColor.rgbColor,fontSize"
            }
          }
        ]
      })
    }).then((r) => this.handleResponse(r));
  }

  updateShapeText(presentationId, shapeId, text) {
    return fetch(`https://slides.googleapis.com/v1/presentations/${presentationId}:batchUpdate`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        //update this token with yours.
        Authorization: `Bearer ${ACCESS_TOKEN}`
      },
      body: JSON.stringify({
        requests: [
          {
            insertText: {
              objectId: shapeId,
              text: text
            }
          }
        ]
      })
    }).then((r) => this.handleResponse(r));
  }

  updateShape(presentationId, shapeId, chartIndex) {
    const { dataset } = this.props;

    const eFullHeight = {
      magnitude: 5143500,
      unit: "EMU"
    };

    const eFullWidth = {
      magnitude: 9144000,
      unit: "EMU"
    };

    const emu4M = {
      magnitude: 3300000,
      unit: "EMU"
    };

    const eSmall = {
      magnitude: 3000000,
      unit: "EMU"
    };

    return fetch(`https://slides.googleapis.com/v1/presentations/${presentationId}:batchUpdate`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        //update this token with yours.
        Authorization: `Bearer ${ACCESS_TOKEN}`
      },
      body: JSON.stringify({
        requests: [
          {
            updateShapeProperties: {
              objectId: shapeId,
              shapeProperties: {
                shapeBackgroundFill: {
                  solidFill: {
                    color: {
                      rgbColor: {
                        red: 76.0 / 255.0,
                        green: 51.0 / 255.0,
                        blue: 114.0 / 255.0
                      }
                    }
                  }
                }
              },
              fields: "shapeBackgroundFill.solidFill.color"
            }
          }
        ]
      })
    }).then((r) => this.handleResponse(r));
  }

  addChart(sheetId, chart, startRow) {
    const { dataset } = this.props;

    const retData = chart?.chart?.data;

    const rColor = rgb(chart?.color);

    return fetch(`https://sheets.googleapis.com/v4/spreadsheets/${sheetId}:batchUpdate`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        //update this token with yours.
        Authorization: `Bearer ${ACCESS_TOKEN}`
      },
      body: JSON.stringify({
        requests: [
          {
            addChart: {
              chart: {
                spec: {
                  title: chart?.narrative?.title,
                  basicChart: {
                    chartType: "COLUMN",
                    legendPosition: "BOTTOM_LEGEND",
                    axis: [
                      {
                        position: "BOTTOM_AXIS"
                      },
                      {
                        position: "LEFT_AXIS",
                        title: dataset?.outcome
                      }
                    ],
                    domains: [
                      {
                        domain: {
                          sourceRange: {
                            sources: [
                              {
                                sheetId: 0,
                                startRowIndex: startRow,
                                endRowIndex: startRow + retData.length + 1,
                                startColumnIndex: 0,
                                endColumnIndex: 1
                              }
                            ]
                          }
                        }
                      }
                    ],
                    series: [
                      {
                        series: {
                          sourceRange: {
                            sources: [
                              {
                                sheetId: 0,
                                startRowIndex: startRow,
                                endRowIndex: startRow + retData.length + 1,
                                startColumnIndex: 1,
                                endColumnIndex: 2
                              }
                            ]
                          }
                        },
                        colorStyle: {
                          rgbColor: {
                            red: rColor.r / 255,
                            green: rColor.g / 255,
                            blue: rColor.b / 255,
                            alpha: rColor.opacity
                          }
                        },
                        targetAxis: "LEFT_AXIS"
                      },
                      {
                        series: {
                          sourceRange: {
                            sources: [
                              {
                                sheetId: 0,
                                startRowIndex: startRow,
                                endRowIndex: startRow + retData.length + 1,
                                startColumnIndex: 2,
                                endColumnIndex: 3
                              }
                            ]
                          }
                        },
                        colorStyle: {
                          rgbColor: {
                            red: 153 / 255,
                            green: 153 / 255,
                            blue: 153 / 255,
                            alpha: 1
                          }
                        },
                        targetAxis: "LEFT_AXIS"
                      }
                    ],
                    headerCount: 1
                  }
                },
                position: {
                  newSheet: true
                }
              }
            }
          }
        ]
      })
    }).then((r) => this.handleResponse(r));
  }

  addChartFirstOrder(sheetId, chart, startRow) {
    const { dataset } = this.props;

    const retData = chart?.chart?.data;

    const rColor = rgb(chart?.color);

    return fetch(`https://sheets.googleapis.com/v4/spreadsheets/${sheetId}:batchUpdate`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        //update this token with yours.
        Authorization: `Bearer ${ACCESS_TOKEN}`
      },
      body: JSON.stringify({
        requests: [
          {
            addChart: {
              chart: {
                spec: {
                  title: chart?.narrative?.title,
                  basicChart: {
                    chartType: "COLUMN",
                    legendPosition: "BOTTOM_LEGEND",
                    axis: [
                      {
                        position: "BOTTOM_AXIS"
                      },
                      {
                        position: "LEFT_AXIS",
                        title: dataset?.outcome
                      }
                    ],
                    domains: [
                      {
                        domain: {
                          sourceRange: {
                            sources: [
                              {
                                sheetId: 0,
                                startRowIndex: startRow,
                                endRowIndex: startRow + retData.length + 1,
                                startColumnIndex: 0,
                                endColumnIndex: 1
                              }
                            ]
                          }
                        }
                      }
                    ],
                    series: [
                      {
                        series: {
                          sourceRange: {
                            sources: [
                              {
                                sheetId: 0,
                                startRowIndex: startRow,
                                endRowIndex: startRow + retData.length + 1,
                                startColumnIndex: 1,
                                endColumnIndex: 2
                              }
                            ]
                          }
                        },
                        colorStyle: {
                          rgbColor: {
                            red: rColor.r / 255,
                            green: rColor.g / 255,
                            blue: rColor.b / 255,
                            alpha: rColor.opacity
                          }
                        },
                        targetAxis: "LEFT_AXIS"
                      }
                    ],
                    headerCount: 1
                  }
                },
                position: {
                  newSheet: true
                }
              }
            }
          }
        ]
      })
    }).then((r) => this.handleResponse(r));
  }

  addImageToSlide(
    presentationId,
    slideId,
    url,
    transform,
    height = { magnitude: 5143500, unit: "EMU" },
    width = {
      magnitude: 9144000,
      unit: "EMU"
    }
  ) {
    return fetch(`https://slides.googleapis.com/v1/presentations/${presentationId}:batchUpdate`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        //update this token with yours.
        Authorization: `Bearer ${ACCESS_TOKEN}`
      },
      body: JSON.stringify({
        requests: [
          {
            createImage: {
              elementProperties: {
                pageObjectId: slideId,
                size: {
                  height: height,
                  width: width
                },
                transform: transform
              },
              url: url
            }
          }
        ]
      })
    }).then((r) => this.handleResponse(r));
  }

  addChartsToSlide(sheetId, presentationId, slideId, chartId, chartIndex, slideIndex) {
    console.log("what is chartId chartIndex", chartId, chartIndex);
    const emu4M = {
      magnitude: 3300000,
      unit: "EMU"
    };

    const eWidth = {
      magnitude: 7200000,
      unit: "EMU"
    };

    const eSmall = {
      magnitude: 3000000,
      unit: "EMU"
    };

    const eFullHeight = {
      magnitude: 5143500,
      unit: "EMU"
    };

    const eFullWidth = {
      magnitude: 9144000,
      unit: "EMU"
    };

    return fetch(`https://slides.googleapis.com/v1/presentations/${presentationId}:batchUpdate`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        //update this token with yours.
        Authorization: `Bearer ${ACCESS_TOKEN}`
      },
      body: JSON.stringify({
        requests: [
          {
            createSheetsChart: {
              objectId: "MyChartId_" + chartId + "_" + chartIndex,
              spreadsheetId: sheetId,
              chartId: chartId,
              linkingMode: "LINKED",
              elementProperties: {
                pageObjectId: slideId,
                size: {
                  height: chartIndex === -1 ? eFullHeight : chartIndex === 0 ? emu4M : eSmall,
                  width: chartIndex === -1 ? eFullWidth : chartIndex === 0 ? eWidth : eSmall
                },
                transform: {
                  scaleX: 1,
                  scaleY: 1,
                  translateX:
                    chartIndex === -1
                      ? 0
                      : chartIndex === 0
                        ? 800000
                        : chartIndex === 1
                          ? 0
                          : chartIndex === 2
                            ? 3000000
                            : chartIndex === 3
                              ? 6000000
                              : 6000000,
                  translateY:
                    chartIndex === -1
                      ? 0
                      : chartIndex === 0
                        ? 0
                        : chartIndex === 1
                          ? 2700000
                          : chartIndex === 2
                            ? 2700000
                            : chartIndex === 3
                              ? 2700000
                              : 2700000,
                  unit: "EMU"
                }
              }
            }
          }
        ]
      })
    }).then((r) => this.handleResponse(r));
  }

  handleResponse(response) {
    return response.json();
  }

  renderSlidesExport(bText = "Export to Slides") {
    const { isGoogleMode, isGoogleAuthed, updateIsGoogleAuthed } = this.props;

    const { isGoogleLogin, isDashboardBuilding } = this.state;

    const onSuccess = (res) => {
      ACCESS_TOKEN = res?.tokenObj?.access_token;
      console.log("success!:", res);

      this.handleExport();

      //updateIsGoogleAuthed(true);
    };
    const onFailure = (err) => {
      console.log("failed:", err);
    };

    return (
      <div
        style={{
          marginRight: "5px"
        }}
        className={isGoogleMode ? styles.googleModeSlides : ""}
      >
        {false && (
          <GoogleLogout
            clientId={CLIENT_ID}
            buttonText="Logout"
            onLogoutSuccess={(e) => console.log("logout suc", e)}
          ></GoogleLogout>
        )}
        {isGoogleLogin ? (
          <div style={{ display: "none" }}>
            <GoogleLogin
              clientId={CLIENT_ID}
              buttonText="Sign in with Google"
              onSuccess={onSuccess}
              onFailure={onFailure}
              cookiePolicy={"single_host_origin"}
              autoLoad={true}
              isSignedOn={true}
            />
          </div>
        ) : (
          <div />
        )}
        {isDashboardBuilding ? (
          <LoadingIndicator style={{ margin: "0px" }} />
        ) : (
          <Button
            onClick={() => {
              if (isGoogleAuthed === true) {
                this.handleExport();
              } else {
                this.setState({ isGoogleLogin: true });
              }
            }}
            isSmall
            style={{ whiteSpace: "nowrap" }}
          >
            {bText}
          </Button>
        )}
      </div>
    );
  }

  render() {
    return <div>{this.renderSlidesExport()}</div>;
  }
}
